import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { CruisePurchaseFormType } from '../components/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<CruisePurchaseFormType>();
  const [cruisePurchases, otherCost, discount] = useWatch({
    control,
    name: ['cruisePurchases', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = (cruisePurchases || []).reduce((prev, cp) => {
      const subtotalGuest = cp.isGroupedPrice
        ? (cp.cruisePurchaseDetails[0].basicFare || 0) +
          (cp.cruisePurchaseDetails[0].tax || 0) +
          (cp.cruisePurchaseDetails[0].tipping || 0) +
          (cp.cruisePurchaseDetails[0].portCharge || 0)
        : cp.cruisePurchaseDetails.reduce((prev, cpd) => {
            return (
              prev +
              (cpd.basicFare || 0) +
              (cpd.portCharge || 0) +
              (cpd.tax || 0) +
              (cpd.tipping || 0)
            );
          }, 0);

      const subtotalAddOns = cp.cruisePurchaseAddOns.reduce(
        (prev, cpao) => prev + (cpao.price || 0),
        0,
      );
      return prev + subtotalGuest + subtotalAddOns;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [cruisePurchases, discount, otherCost, setValue]);

  return data;
}
